import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { HttpInterceptor } from '../shared/index';
import { CONSTANT_VALUES } from '../constants/constant-values';
import { environment } from '../../environments/environment';
import { Group } from './group'

@Injectable()
export class GroupService {
  constructor(private http: HttpInterceptor) {
  }
  /**
   * Get member list in specific group
   *
   * @param {any} vendorObject
   * @returns
   *
   * @memberOf GroupService
   */
  getListOfMemberByGroup(vendorObject) {
    let url = CONSTANT_VALUES.URL_GET_GROUP_MEMBERS;
    return new Promise((resolve, reject) => {
      this.http.post(url, vendorObject).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Create group of members
   *
   * @param {Group} groupObj
   * @returns
   *
   * @memberOf GroupService
   */
  createGroup(groupObj: Group) {
    let url = CONSTANT_VALUES.URL_CREATE_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, groupObj).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Get members list excluding group member
   *
   * @param {any} groupObj
   * @returns
   *
   * @memberOf GroupService
   */
  getMemberListNotInGroup(groupObj) {
    let url = CONSTANT_VALUES.URL_GET_MEMBERS_NOT_IN_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, groupObj).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Edit group name service call
   *
   * @param {any} groupObj
   * @returns
   *
   * @memberOf GroupService
   */
  updateGroupName(groupObj) {
    let url = CONSTANT_VALUES.URL_UPDATE_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, groupObj).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }

  removeMemberFromGroup(groupObj) {
    let url = CONSTANT_VALUES.URL_REMOVE_MEMBERS_FROM_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, groupObj).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Call API for to add multiple members in existing group
   *
   * @param {any} groupObj
   * @returns
   *
   * @memberOf GroupService
   */
  addMemberInExistingGroup(groupObj) {
    let url = CONSTANT_VALUES.URL_ADD_MEMBERS_IN_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, groupObj).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Disable/Enable/Activate/Deactivate group API call
   *
   * @param {any} reqObject
   * @returns
   *
   * @memberOf GroupService
   */
  groupActionAPI(reqObject) {
    let url = CONSTANT_VALUES.URL_ACTION_ON_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
  /**
   * Delete group API call
   *
   * @param {any} reqObject
   * @returns
   *
   * @memberOf GroupService
   */
  deleteGroup(reqObject) {
    let url = CONSTANT_VALUES.URL_DELETE_GROUP;
    return new Promise((resolve, reject) => {
      this.http.post(url, reqObject).map((res) => res.json()).subscribe(data => {
        resolve(data);
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/group/group.service.ts